import { IMapGeoObject } from '@cian/frontend-newbuilding-map-component';
import { IResidentialComplex } from '../../../types/residentials';
import { getGeoObject } from './getGeoObject';

export function getPins(complexes: IResidentialComplex[]): IMapGeoObject[] {
  return complexes.reduce((acc, curr) => {
    const pin = getGeoObject({
      markAsPlus: curr.displayType === 'plus',
      name: String(curr.id),
      id: String(curr.id),
      coordinates: curr.coordinates,
    });

    if (!pin) {
      return acc;
    }

    return [...acc, pin];
  }, Array.of<IMapGeoObject>());
}
